import React, { useContext, useState, useEffect } from 'react';
import { CloseRounded } from '@mui/icons-material';
import { Button, MenuItem, Select, TextField, CircularProgress } from '@mui/material';
import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';
import CustomButton from '../../../common/CustomButton';
import { toast } from 'react-toastify';

const CreateCouponModal = ({ modalDetails }) => {
    const company = modalDetails.companyDetails;
    const acceptAction = modalDetails.acceptAction;
    const modalCtx = useContext(ModalContext);
    const authCtx = useContext(AuthContext);
    const [loading, setLoading] = useState(false);

    const closeHandle = () => {
        modalCtx.closeModal();
    }

    const handleCreateCoupon = async () => {
        setLoading(true);
        try {
            const firstContactId = company.allContacts && company.allContacts.length > 0 ? company.allContacts[0].id : 0;

            const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/coupon/step/init`, {
                method: "POST",
                headers: { 
                    'Content-Type': 'application/json', 
                    Authorization: "Bearer " + authCtx.token 
                },
                body: JSON.stringify({
                    companyId: company.id,
                    contactId: firstContactId,
                    status: 'draft'
                })
            });
            
            const data = await response.json();
            
            if (data.status === 'success') {
                // Pass the created coupon ID to the parent component
                acceptAction(data.data.couponId);
                // Set the page update with couponId
                modalCtx.setPageUpdate({ 
                    page: "CreateCouponV2", 
                    couponId: data.data.couponId,
                    keywords: company.companyDetails.keywords,
                    step: 0
                });
            }
        } catch (error) {
            console.error('Error creating coupon:', error);
            toast.error('Failed to create coupon. Please try again.');
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div className="create-devotional-container create-coupon-modal">
                <div className='coupon-modal-header'>
                    <CloseRounded className='close' onClick={() => closeHandle()} />
                </div>
                <div className="body-container coupon-body-container">
                    <img src={company.logo} alt={company.companyDetails.company} />
                    <h1>{company.companyDetails.company}</h1>
                    <span>Let's create a coupon!</span>
                    <CustomButton className="deliva-btn" onClick={handleCreateCoupon} disabled={loading}>
                        {loading ? <CircularProgress size={24} color="inherit" /> : 'Accept'}
                    </CustomButton>
                </div>
            </div>
        </>
    )
}

export default CreateCouponModal;
